// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-ImplicationBlock-ImplicationBlockSmall__implication--3ubvx{display:inline-block;width:16rem;height:36rem;position:relative;overflow:hidden;margin-left:2rem}.src-components-ImplicationBlock-ImplicationBlockSmall__darken--2d8YJ{background-color:rgba(0,0,0,.7)}.src-components-ImplicationBlock-ImplicationBlockSmall__darken--2d8YJ,.src-components-ImplicationBlock-ImplicationBlockSmall__highlight--19ea6{position:absolute;width:100%;height:100%;top:0;left:0}.src-components-ImplicationBlock-ImplicationBlockSmall__highlight--19ea6{box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"implication": "src-components-ImplicationBlock-ImplicationBlockSmall__implication--3ubvx",
	"darken": "src-components-ImplicationBlock-ImplicationBlockSmall__darken--2d8YJ",
	"highlight": "src-components-ImplicationBlock-ImplicationBlockSmall__highlight--19ea6"
};
module.exports = exports;
